<template>
<div class="chapter">
<div class="inner_page">
<p class="praise-tit"><span class="txbf">PRAISE FOR</span></p>
<p class="praise-tit1">DR. HAGGARD’S DISEASE</p>
<p class="center">‘No one writes a dark epiphany like McGrath . . . The horror, as ever with Patrick McGrath, is not external, Edward Haggard becomes its locus, our trick-narrator, the voice of reason, the grimacing guardian of surprise . . . McGrath’s most chilling castaway yet, and his most enduring’ — Tom Adair in <span class="txit">Scotland on Sunday</span></p>
<p class="center">‘Outstanding . . . a Gothic tour de force of doomed love, unsavory secrets, morphine, disfigurement, untimely death and a physician who will not heal himself . . . The final denouement, where event and delusion combine, delivers a terrible and a brilliant coup’ — Katherine A. Powers in the <span class="txit">Boston Globe</span></p>
<p class="center"><span class="txit">‘Dr Haggard’s Disease</span> leaves one yet again impressed by how well Patrick McGrath writes. Few novelists use language as gracefully, as effectively, as economically as he does’ — Eileen Battersby in the <span class="txit">Irish Times</span></p>
<p class="center">‘McGrath’s brilliant design weaves delicate parallels in plot with nubbed grotesqueries of name and event to produce a seamless but richly textured psychic mystery . . . sets the neck hairs creeping’ — Katherine Dunn in the <span class="txit">Washington Post</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?8b32e672